import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { ThemePage } from "../components/lidoo/theme-page";
import { clubsByTheme } from "../lib/api/lidoo.functions";
import { DICTS, fill, LOCALIZED_LANGS, type Lang } from "../lib/i18n";
import { isIndexableLocale, NOINDEX_META } from "../lib/indexing";
import { catalogueHreflang } from "../lib/seo";
import { themeFromSlug } from "../lib/themes";

export const Route = createFileRoute("/$locale/theme/$theme/")({
  beforeLoad: ({ params }) => {
    if (params.locale === "en")
      throw redirect({ to: "/theme/$theme", params: { theme: params.theme } });
    if (!LOCALIZED_LANGS.includes(params.locale as Lang)) throw notFound();
  },
  loader: async ({ params }) => {
    const theme = themeFromSlug(params.theme);
    if (!theme) throw notFound();
    const res = await clubsByTheme({ data: { theme } });
    return { ...res, theme };
  },
  head: (ctx) => {
    const d = DICTS[ctx.params.locale as Lang];
    const theme = ctx.loaderData?.theme;
    if (!d || !theme) return {};
    const what = d[`th_${theme}`] ?? "";
    return {
      meta: [
        { title: `${what} | sunbedly` },
        {
          name: "description",
          content: fill(d.th_meta_all, {
            what,
            n: String(ctx.loaderData?.clubs.length ?? 0),
            r: String(ctx.loaderData?.regions.length ?? 0),
          }),
        },
        // Machine-translated languages stay out of the index (lib/indexing.ts).
        ...(isIndexableLocale(ctx.params.locale) ? [] : [NOINDEX_META]),
      ],
      links: catalogueHreflang(`/theme/${ctx.params.theme}`, ctx.params.locale),
    };
  },
  component: LocaleThemeIndexPage,
});

function LocaleThemeIndexPage() {
  const { theme, clubs, regions } = Route.useLoaderData();
  return <ThemePage theme={theme} clubs={clubs} regions={regions} />;
}
